import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { ProfileInfoCard, StatusBadge, ViewButton } from "@components";

import { useFunctionalityData } from "@hooks/useFunctionalityData";
import { useLanguage } from "@hooks/useLanguage";

import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";
import { LeaveType } from "@type/HRM/leaves";

import { ROUTES } from "@constants/routes";
import { STATUS } from "@constants/status.hrm";
import { FUNCTIONALITY_DATA } from "@constants/functionality-data";

const { LEAVE_TYPE } = FUNCTIONALITY_DATA;
const { APPROVED, REJECTED } = STATUS;
const {
  HRM: { LEAVE },
} = ROUTES;

export const TableColumn = (t: TFunction<"translation", undefined>) => {
  const { language } = useLanguage();

  const { data: leaveType } = useFunctionalityData(LEAVE_TYPE);

  return [
    {
      id: 1,
      key: "employeeID",
      name: t("LEAVE_LIST.TABLE.COLUMN.NAME"),
      render: (_: any, row: LeaveType) => (
        <ProfileInfoCard employee={row.employee} />
      ),
    },
    {
      id: 2,
      key: "employeeCode",
      name: t("LEAVE_LIST.TABLE.COLUMN.EMPLOYEE_ID"),
      render: (employeeCode: number) => (
        <Text color="info">{employeeCode}</Text>
      ),
    },
    {
      id: 9,
      key: "leaveTypeId",
      name: t("LEAVE_LIST.TABLE.COLUMN.LEAVE_TYPE"),
      render: (leaveTypeId: number) => {
        const item = leaveType?.find((item: any) => item.id === leaveTypeId);

        return (
          <Text color="subtitle1">
            {language === "bn" ? item?.nameBn : item?.name}
          </Text>
        );
      },
    },
    {
      id: 3,
      key: "startDate",
      name: t("LEAVE_LIST.TABLE.COLUMN.FROM_DATE"),
      render: (startDate: string) => <Text color="subtitle1" className="text-nowrap">{startDate}</Text>,
    },
    {
      id: 4,
      key: "endDate",
      name: t("LEAVE_LIST.TABLE.COLUMN.TO_DATE"),
      render: (endDate: string) => <Text color="subtitle1" className="text-nowrap">{endDate}</Text>,
    },
    {
      id: 5,
      key: "leaveDaysCount",
      name: t("LEAVE_LIST.TABLE.COLUMN.DURATION"),
      render: (leaveDaysCount: number) => (
        <Text color="subtitle1">{`${leaveDaysCount} Day${
          leaveDaysCount > 0 ? "s" : ""
        }`}</Text>
      ),
    },
    {
      id: 6,
      key: "status",
      name: t("LEAVE_LIST.TABLE.COLUMN.STATUS"),
      render: (status: string) => <StatusBadge status={status} />,
    },
    {
      id: 7,
      key: "fileOnHandObject",
      name: t("LEAVE_LIST.TABLE.COLUMN.FILE_ON_HAND"),
      render: (fileOnHandObject: EmployeeCommonInfoType, row: any) => {
        return fileOnHandObject !== null &&
          row.status !== APPROVED &&
          row.status !== REJECTED ? (
          <ProfileInfoCard employee={fileOnHandObject} />
        ) : (
          <></>
        );
      },
    },
    {
      id: 8,
      key: "view",
      render: (_: any, row: LeaveType) => {
        return (
          <ViewButton link={`${LEAVE}/${row.employeeMasterId}/${row.id}`} />
        );
      },
    },
  ];
};
